import styled from 'styled-components'

export const DiscountVoucherContainer = styled.div`
  padding: 0 10px;

  & .success-code {
    color: green;
  }

  & .error-code {
    color: red;
  }
`

export const DiscountAreaHeader = styled.h2`
  font-size: 22px;
  font-family: 'RL Aqva Black';
  color: #264b94;
  text-align: center;
  margin-top: 25px;
  margin-bottom: 0;
`

export const DiscountContainer = styled.div`
  display: flex;

  & button {
    white-space: nowrap;
    margin-left: 15px;
    padding-left: 10px;
    padding-right: 10px;
  }
`

export const TextInputStyled = styled.input`
  border: 1px solid ${({ theme }) => theme.inputBorderColour};
  border-radius: ${({ theme }) => theme.formControlBorderRadius};
  padding: 0 ${({ theme }) => theme.formControlHorizontalPadding};
  padding: 0 ${({ theme }) => theme.formControlHorizontalPadding};
  margin-bottom: ${({ theme }) => theme.formControlBottomMargin};
  color: ${({ theme }) => theme.primaryTextColour};
  font-size: ${({ theme }) => theme.generalFontSize};
  height: 50px;
  width: 100%;
  font-family: ${({ theme }) => theme.fontFamily};
  font-style: ${({ theme }) => theme.fontStyle};
  font-weight: ${({ theme }) => theme.fontWeight};
  -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
  -moz-box-sizing: border-box; /* Firefox, other Gecko */
  box-sizing: border-box; /* Opera/IE 8+ */

  @media (min-width: 768px) {
    height: 60px;
  }

  :focus {
    border: 1px solid ${({ theme }) => theme.inputActiveBorderColour} !important;
    outline: 1px solid ${({ theme }) => theme.inputActiveBorderColour} !important;
  }
  ::-ms-clear {
    display: none;
  }
  ::placeholder {
    text-transform: none;
  }
`
